/* eslint-disable no-param-reassign */
import { BaseSchemaProcessor } from './base-schema-processor';

export class SelAccountLevelListsGridSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    // Hide filterable fields that are in the entitySchema but not in this grid.
    const entityNameProperty = entitySchema.properties.EntityName;
    const sharedEntityCustomerIdProperty = entitySchema.properties.SharedEntityCustomerId;

    if (entityNameProperty) {
      entityNameProperty.filterable = false;
    }

    if (sharedEntityCustomerIdProperty) {
      sharedEntityCustomerIdProperty.filterable = false;
    }

    return entitySchema;
  }
}
